import ActionHandler from '@/js/components/forms/action_handler';

/**
 * Month navigation for the congress calendar.
 *
 * Each arrow posts action=calendar with the month it targets; the controller
 * returns the re-rendered calendar and ActionResponseData swaps it in and
 * updates the url. The swap replaces the element, so the arrows have to be
 * bound again on the 'update' event it dispatches.
 */
class Overview {
  constructor() {
    this.props = {
      calendarId: 'conferences-calendar',
      url: window.location.pathname,
    };

    this.dom = {
      calendar: document.getElementById(this.props.calendarId),
    };

    this.components = {
      actionHandler: new ActionHandler(),
    };

    this.events = {
      onNavClick: this.onNavClick.bind(this),
      onCalendarUpdate: this.initializeCalendar.bind(this),
    };
  }

  mount() {
    this.initializeCalendar();
  }

  initializeCalendar() {
    this.dom.calendar = document.getElementById(this.props.calendarId);

    if (!this.dom.calendar) return;

    this.dom.calendar.querySelectorAll('[data-calendar-month]').forEach((button) => {
      button.addEventListener('click', this.events.onNavClick);
    });

    this.dom.calendar.addEventListener('update', this.events.onCalendarUpdate);
  }

  /**
   * @param e {Event}
   */
  onNavClick(e) {
    e.preventDefault();

    const { calendarMonth } = e.currentTarget.dataset;

    if (!calendarMonth) return;

    const formData = new FormData();
    formData.append('month', calendarMonth);

    this.components.actionHandler.send({
      url: this.props.url,
      formData,
      action: 'calendar',
    });
  }
}

if (document.getElementById('page-conferences-overview')) {
  // eslint-disable-next-line no-new
  new Overview().mount();
}
